import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ListChecks,
  FileText,
  Send,
  Settings,
  LogOut,
  Mail,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/campagne", label: "Campagne", icon: Send, testid: "nav-campagne" },
  { to: "/contatti", label: "Contatti", icon: Users, testid: "nav-contatti" },
  { to: "/liste", label: "Liste", icon: ListChecks, testid: "nav-liste" },
  { to: "/template", label: "Template", icon: FileText, testid: "nav-template" },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings, testid: "nav-impostazioni" },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid" style={{ gridTemplateColumns: "260px 1fr" }}>
      {/* Sidebar */}
      <aside
        className="border-r border-border bg-white flex flex-col"
        data-testid="app-sidebar"
      >
        <div className="px-6 py-6 border-b border-border">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-sm bg-primary grid place-items-center">
              <Mail className="w-4 h-4 text-primary-foreground" />
            </div>
            <div>
              <div className="font-heading font-medium text-base leading-none">TECSend</div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1">
                Newsletter M365
              </div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 text-sm rounded-sm transition-colors ${
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-foreground hover:bg-muted"
                  }`
                }
              >
                <Icon className="w-4 h-4" strokeWidth={1.75} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="border-t border-border p-4">
          <div className="text-xs text-muted-foreground mb-1">Connesso come</div>
          <div className="text-sm font-medium truncate" data-testid="user-email">
            {user?.email}
          </div>
          <div className="mt-3 flex items-center gap-2 text-xs">
            <span
              className={`inline-block w-2 h-2 rounded-full ${
                user?.microsoft_connected ? "bg-primary" : "bg-muted-foreground/40"
              }`}
              data-testid="ms-status-dot"
            />
            <span className="text-muted-foreground">
              {user?.microsoft_connected
                ? `M365: ${user?.microsoft_email || "connesso"}`
                : "Microsoft 365 non collegato"}
            </span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start mt-3 text-muted-foreground hover:text-foreground"
            onClick={() => {
              logout();
              navigate("/login");
            }}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Esci
          </Button>
        </div>
      </aside>

      {/* Content */}
      <main className="min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
